<template>
    <v-container>
        <v-layout wrap>
            <v-flex xs12>
                <w-main-title
                        :title="'Hola ' + (currentUser && currentUser.first_name || '') + '!' "
                        :breadcrumbs="breadcrumbs"
                ></w-main-title>
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex xs12>
                <account-activation-listener
                        ref="activationListener"
                        :onCodeRequestFail="onCodeRequestFail"
                        :onAccountActivated="onAccountActivated"
                        :onActivationCodeSent="onActivationCodeSent"
                ></account-activation-listener>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import PanelMenu from '@/components/common/panel/PanelMenu'
    import WMainTitle from '@/components/common/WMainTitle'
    import KimsaAlert from '@/components/common/KimsaAlert'
    import AccountActivationListener from '@/components/account/AccountActivationListener'

    import {mapState, mapMutations} from 'vuex'

    export default{
        components:{
            PanelMenu,
            WMainTitle,
            KimsaAlert,
            AccountActivationListener
        },
        mounted(){
            var vm = this

            vm.startListening()
        },
        data(){
            return {
                breadcrumbs: [
                    {
                        text: 'Dashboard',
                        disabled: false,
                        to: {name: 'panel.dashboard'}
                    },
                    {
                        text: 'Activar Cuenta',
                        disabled: true,
                        to: ''
                    },
                ]
            }
        },
        computed:{
            ...mapState(['currentUser'])
        },
        methods:{

            ...mapMutations(['showSnackBar']),

            onActivationCodeSent(){
                var vm = this
                vm.showSnackBar('Nuevo link enviado')
            },

            onAccountActivated(){
                var vm = this
                vm.showSnackBar('Cuenta Activada!')
                vm.$router.replace({name: 'panel.dashboard'})
            },

            onCodeRequestFail(err){
                var vm = this
                vm.showSnackBar('Ocurrió un error solicitando un nuevo código')
            },

            startListening(){
                var vm = this
                if(vm.currentUser){
                    vm.$refs.activationListener.startListening(vm.currentUser.id)
                }
            }
        },
        watch:{
            currentUser(user){
                if(user){
                    var vm = this
                    vm.$refs.activationListener.startListening(vm.currentUser.id)
                }
            }
        }
    }
</script>